<template>
    <div class="mb-0">
      <div class="form-check form-switch">
        <input
          class="form-check-input"
          type="checkbox"
          :checked="modelValue"
          @change="updateValue"
          :id="id"
        />
        <label class="form-check-label" :for="id">{{ label }}</label>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "ProfileCheckbox",
    props: {
      label: {
        type: String,
        required: true,
      },
      id: {
        type: String,
        required: true,
      },
      modelValue: {
        type: Boolean,
        required: true,
      },
    },
    methods: {
      updateValue(event) {
        this.$emit("update:modelValue", event.target.checked);
      },
    },
  };
  </script>